import './Footer.css';

function Footer() {
  return (
    <footer>
      <p>&copy; 2025 Bookkeeper | INF 124 Group 27</p>
    </footer>
  );
}

export default Footer;

